import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-fee-change-warning-dialog',
    template: require('./feeChangeWarningDialog.html')
})
export class FeeChangeWarningDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<FeeChangeWarningDialog>) public dialogRef: MatDialogRef<FeeChangeWarningDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
